<template>
    <div class='huodong'>
        <header class="mint-header" @click="$router.go(-1)">
            <div class="mint-header-button is-left">
                <a class="router-link-exact-active router-link-active">
                    <button class="mint-button mint-button--default mint-button--normal">
                        <span class="mint-button-icon"><i class="mintui mintui-back"></i></span> 
                        <label class="mint-button-text">返回</label>
                    </button>
                </a>
            </div> 
        </header>
        <div class='huodong-title'>天梯产品代理人(又称客户经理)推广备课小助手的销售规则</div>
        <div class='hd-item'>
            <div class='item-t'>1.时间</div>
            <div class='item-c'>2019年3月1日-2020年3月1日</div>
        </div>
        <div class='hd-item'>
            <div class='item-t'>2.服务区域(对象)及产品定义</div>
            <div class='item-t'>A.单一教师销售</div>
            <div class='item-c'>a)客户经理必须以天梯扫描设备为载体的实物销售到对应的教师用户那里,老师应凭借设备的唯一编码(位于设备底部的11位数字编码)进行有效注册,这样就完成了客户经理对应教师用户管理权限的认定;对教师无身份认证限制,但同一:手机号码/微信号/设备编码只能被注册一次;</div>
            <div class='item-c'>b)公司只承诺客户经理对编码所对应教师账户进行保护性关系维护,对同一教师使用多人提供的设备码进行的多身份账户不进行干涉,即允许同一老师利用不同账号同时接受不同客户经理的服务;</div>
            <div class='item-c'>c)客户经理需要通过“天梯客户经理人公众号”里面的用户管理功能,对自己发出的设备码在教师用户首次注册时进行确认;未经客户经理确认的注册为无效注册</div>
            <div class='item-t'>B.须对某一学校封闭销售服务的报备制约定</div>
            <div class='item-c'>a)此项权限为大客户经理权限,普通客户经理须升级为大客户经理后方可以使用本项权限;封闭服务后的学校,不再允许其他客户经理进行销售,本校教师身份将会被锁定,即使本校教师拿到其他客户经理窜货提供的设备也无法进行注册;查询升级条件详见<span @click="ruleEventClick" class="special-rule">升级规则</span>;</div>
            <div class='item-c'>b)报备的前提条件为:对应学校为首次接洽公司本产品(即本校无任何老师使用过公司本产品),同一地区的大客户经理以网上生产有效定单时间为授权标准,先报先授;同一学校只能接受一位大客户经理的封闭报备;</div>
            <div class='item-c'>c)报备方式:以网上下单(必须以报备学校总教师人数为对应设备数量的有效订单)报备为依据;</div>
            <div class='item-t'>C.产品定价及零售价原则</div>
            <div class='item-c'>本型号《备课小助手》系统产品全国同一零售定价1480元;原则上对学校直接开票不得低于此价格,各客户经理对用户的销售折扣系客户经理个人行为,在不需要公司对学校直接开具发票的前提下,公司不做干涉;在恶意竞争的情况前提下,对于客户经理以低于零售价销售的行为、公司保留对用户账号直接关闭部分软件功能的权力(免费对用户赠送的行为不被定义为恶意竞争);</div>
            <div class='item-t'>D.退换货原则</div>
            <div class='item-c'>参照遵守国家规定的的电子产品三包标准;对非人为破坏因素下,出现的产品质量问题遵循一下原则:7日包退,3个月包换,1年包修,终身保修;</div>
            <div class='item-c'>以客户经理订单签收日期为包退计算起始日期;以用户注册日期为包换、包修标准的计算起始日期;</div>
            <div class='item-c' style="color: red">注:对已经被激活通过的鼠标码所对应的鼠标,公司不接受退货,客户经理对此类鼠标不可以进行退货!</div>
        </div>
        <div class='hd-item'>
            <div class='item-t'>3.其他说明</div>
            <div class='item-c'>a)对于客户经理的拿货同时公司会开具对应的发票,如有特殊情况下,客户经理可以要求公司对其服务的学校用户直接开具发票,公司会代扣超额部分的增值税金(为开票金额减拿货折扣金额后的16%);</div>
            <div class='item-c'>b)对于客户经理要求学校用户直接对公司打款的行为处理原则:公司以营销提成方式返还学校用户打款超出客户经理拿货金额的部分给客户经理,同时公司以退款方式返还客户经理拿货金额部分;</div>
            <div class='item-c'>c)公司禁止任何客户经理对学校用户进行的任何营销返利行为,对于出现的违法违规情况,公司会积极配合有关部门进行处理;</div>
            <div class='item-c'>d)若客户经理获得的任何奖励金(包含但不限于营销提成、福利奖金等)需要依法缴纳相应税款的,公司将根据税务法律要求向税务机关提供必要的税务申报信息(包含您的身份信息,奖励金金额等税务机关要求的信息),并由天梯极阅公司依法为您完成相应税款的代扣代缴;客户经理须遵守国家及本地相关政策规定;如果因未遵守上述规定导致被投诉、处罚或者造成不良影响的,天梯极阅公司将采取相关措施直至撤销客户经理身份;</div>
            <div class='item-c'>e)公司如因市场、运营等实际情况,需要对本销售规则作变更时,将通过官方APP、网站等方式予以公告公布或通知;</div>
        </div>
    </div>
</template>
<script>
export default {
    methods: {
        ruleEventClick() {
            this.$router.replace({
                path: '/message/liucheng1'
            })
        }
    }
}
</script>

<style>
    .huodong {
        position: absolute;
        bottom: 0;
        top: 0;
        left: 0;
        right: 0;
        overflow: auto;
        font-size: 14px;
    }
    .huodong .huodong-title {
        text-align: center;
        font-size: 14px;
        color: #3a4744;
        font-weight: 700;
        margin-top: 10px;
        margin-bottom: 10px;
    }
    .huodong .hd-item {
        margin-bottom: 35px;
        padding: 5px;
        padding-bottom: 0px;
    }
    .huodong .item-t {
        color: #3a4744;
        font-weight: 700;
        margin-bottom: 10px;
    }
    .huodong .item-c {
        color: #253632;
        margin-bottom: 10px;
        letter-spacing: 2px;
    }
    .special-text {
        color: #6264ee;
    }
    .huodong .special-rule {
        color: blue;
        text-decoration: underline;
    }
</style>

